jQuery(document).ready(function($) {

    jQuery(document).foundation();

// // Scroll reveal
window.sr = new ScrollReveal();
 $(window).on('load resize', function() {
    if ($(window).width() > 767) {
        sr.reveal('#contact-us .contact-us-card', {
            delay: 500,
            origin: 'bottom',
            distance: '100px',
            easing: 'cubic-bezier(0.5, 0, 0, 1)'
         });                   
    } else {
        
    }
});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 200
    }, 500);
})

    // Checkout Sticky Details
    if ($('body').hasClass('single-post')){
        const shareButtons = $('.addtoany_shortcode');
        var triggerTop = $('.single-post-content').offset().top - 150;
        var triggerBottom = $('.single-post-content').position().top + $('.single-post-content').outerHeight(true) - 390;

        $(window).on("load resize scroll",function(e){
            var curentScroll = $(window).scrollTop();
            if ($(window).width() > 767) {
                if (curentScroll > triggerTop && curentScroll < triggerBottom) {
                    shareButtons.addClass('sticky');
                    shareButtons.removeClass('unpinned');
                } else if (curentScroll > triggerTop && curentScroll > triggerBottom) {
                    shareButtons.addClass('unpinned');
                    shareButtons.removeClass('sticky');
                } else {
                    shareButtons.removeClass('sticky');
                }
            } else {
                shareButtons.removeClass('sticky unpinned');
            }
        });
}    
    // Gallery Page Masonry Layout
    if($('body').hasClass('page page-id-45')) {
        $(window).load(function() {
            $('.masonry-grid').masonry({
                itemSelector: '.grid-item',
                horizontalOrder: true,
                percentPosition: true        
            });  
        });
    }    
    
    // Prevent Gravity Forms form being submitted twice
    var gformSubmitted = false;
    $(".gform_wrapper form").submit(function(event) {
        if (gformSubmitted) {
            event.preventDefault();
        }
        else {
            gformSubmitted = true;
            $("button[type='submit']", this).html("<i class='fas fa-spinner fa-spin'></i>").attr("disabled", true);
        }
    });

    // Sticky Nav After Scrolling
    $(window).bind('scroll', function() {
        var navHeight = $('#site-navigation .utility-nav').outerHeight();
        if ($(window).scrollTop() > navHeight) {
            $('#main-menu, #content').addClass('fixed');
        } else {
            $('#main-menu, #content').removeClass('fixed');
        }
    });

    $(window).load(function() {
        $('.hamburger').click(function() {
            $(this).toggleClass('active');
            // Mobile Nav - Disable Body Scrolling
            if ($(this).hasClass('active')) {
                $('body').css("overflow", "hidden");
            } else {
                $('body').css("overflow", "auto");
            }
        });
    });
});
